import CheckboxGroup from 'component/atom/forms/checkbox/CheckboxGroup';
import Input from 'component/atom/forms/input/input/Input';
import PhoneInput_ from 'component/atom/forms/phoneInput/PhoneInput';
import RadioGroup from 'component/atom/forms/radio-group/RadioGroup';
import Select from 'component/atom/forms/select/select/Select';
import UploadFile_Form from 'component/atom/forms/upload-file/upload-form-file/UploadFile_Form';
import { mapFieldType } from './mapFieldType';
import DateSelect from 'component/atom/forms/select/date/DateSelect';
import MultiSelectList from 'component/atom/forms/select/multi-select-list/MultiSelectList';

const renderInput = (
  field,
  formik,
  isSubmitted,
  isConversation,
  type = 'text'
) => {
  return (
    <Input
      inputType={type}
      label={field.fieldLabel}
      placeholder={field.placeHolder}
      name={field.fieldLabel}
      value={formik.values[field.fieldLabel]}
      onChange={formik.handleChange}
      onBlur={formik.handleBlur}
      error={formik.errors[field.fieldLabel]}
      touched={formik.touched[field.fieldLabel]}
      inputClassname={formik.inputClassname}
      required={field.isMandatory}
      disabled={isSubmitted || isConversation}
      maxLength={field.characterLimit}
      pattern={field.regex}
      noSvg
    />
  );
};
export const renderDynamicField = (
  field,
  formik,
  isSubmitted,
  isConversation,
  triggerNewConversation
) => {
  const fieldType = mapFieldType(field.fieldType);

  switch (fieldType) {
    case 'select': {
      const isMulti = field.typeSelection === 'multiple';

      if (isMulti) {
        return (
          <MultiSelectList
            label={field.fieldLabel}
            name={field.fieldLabel}
            placeholder={field.placeHolder || 'Select options'}
            value={formik.values[field.fieldLabel]}
            onChange={(e) =>
              formik.setFieldValue(field.fieldLabel, e.target.value)
            }
            touched={formik.touched[field.fieldLabel]}
            error={formik.errors[field.fieldLabel]}
            options={
              field.formsDetailOptions?.map((opt) => ({
                label: opt.optionValue,
                value: opt.optionValue,
              })) || []
            }
            config={{ hasClear: true, hasPlusBtn: false }}
            disabled={isSubmitted || isConversation}
          />
        );
      } else {
        return (
          <Select
            label={field.fieldLabel}
            placeholder={field.placeHolder || 'Select option'}
            name={field.fieldLabel}
            value={formik.values[field.fieldLabel]}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            error={formik.errors[field.fieldLabel]}
            touched={formik.touched[field.fieldLabel]}
            options={
              field.formsDetailOptions?.map((opt) => ({
                label: opt.optionValue,
                value: opt.optionValue,
              })) || []
            }
            disabled={isSubmitted || isConversation}
          />
        );
      }
    }

    case 'phone':
      return (
        <PhoneInput_
          label={field.fieldLabel}
          name={field.fieldLabel}
          value={formik.values[field.fieldLabel]}
          onChange={(val) => formik.setFieldValue(field.fieldLabel, val)}
          onBlur={() => formik.setFieldTouched(field.fieldLabel, true)}
          touched={formik.touched[field.fieldLabel]}
          error={formik.errors[field.fieldLabel]}
          disabled={isSubmitted || isConversation}
        />
      );

    case 'radio':
      return (
        <RadioGroup
          label={field.fieldLabel}
          name={field.fieldLabel}
          selectedValue={formik.values[field.fieldLabel]}
          onChange={(e) =>
            formik.setFieldValue(field.fieldLabel, e.target.value)
          }
          options={
            field.formsDetailOptions?.map((opt) => ({
              label: opt.optionValue,
              value: opt.optionValue,
            })) || []
          }
          error={
            formik.touched[field.fieldLabel] && formik.errors[field.fieldLabel]
          }
          variant="secondary"
          disabled={isSubmitted || isConversation}
        />
      );

    case 'checkbox':
      return (
        <CheckboxGroup
          label={field.fieldLabel}
          name={field.fieldLabel}
          selectedValues={formik.values[field.fieldLabel] || []}
          onChange={(values) => formik.setFieldValue(field.fieldLabel, values)}
          options={
            field.formsDetailOptions?.map((opt) => ({
              label: opt.optionValue,
              value: opt.optionValue,
            })) || []
          }
          error={
            formik.touched[field.fieldLabel] && formik.errors[field.fieldLabel]
          }
          disabled={isSubmitted || isConversation}
        />
      );

    case 'birthdate':
      return (
        <DateSelect
          label={field.fieldLabel}
          name={field.fieldLabel}
          value={formik.values[field.fieldLabel]}
          onChange={(val) => formik.setFieldValue(field.fieldLabel, val)}
          onBlur={() => formik.setFieldTouched(field.fieldLabel, true)}
          touched={formik.touched[field.fieldLabel]}
          error={formik.errors[field.fieldLabel]}
          disabled={isSubmitted || isConversation}
        />
      );

    case 'file': {
      const allowedTypes = field.typeSelection
        .split(',')
        .map((t) => t.trim())
        .filter(Boolean) ?? ['*'];
      return (
        <UploadFile_Form
          title={field.fieldLabel}
          label={field.placeHolder}
          name={field.fieldLabel}
          value={formik.values[field.fieldLabel]}
          onChange={(e) =>
            formik.setFieldValue(field.fieldLabel, e.target.value)
          }
          onBlur={() => formik.setFieldTouched(field.fieldLabel, true)}
          touched={formik.touched[field.fieldLabel]}
          error={formik.errors[field.fieldLabel]}
          type={field.uploadType || 'File'}
          disabled={isSubmitted || isConversation}
          allowedExtensions={allowedTypes}
          triggerNewConversation={triggerNewConversation}
        />
      );
    }
    case 'email':
      return renderInput(field, formik, isSubmitted, isConversation, 'email');

    case 'number':
      return renderInput(field, formik, isSubmitted, isConversation, 'number');

    default:
      return renderInput(field, formik, isSubmitted, isConversation, '');
  }
};
